import { useWorksheetDifficultyStatistics } from '~/@common/hooks/useWorksheetParentReport'

import { DifficultyStatisticsCard } from './DifficultyStatisticsCard'

type Props = {
  studentId?: string | null
  worksheetId?: number | null
}

export const WorksheetDifficultyStatistics = ({ studentId, worksheetId }: Props) => {
  const { data } = useWorksheetDifficultyStatistics(studentId, worksheetId)
  return <DifficultyStatisticsCard data={data ?? []} />
}
